import { Component } from '@angular/core';

@Component({
  selector: 'loyaltic-decorative-side-shapes',
  templateUrl: './decorative-side-shapes.component.html',
  styleUrls: ['./decorative-side-shapes.component.scss']
})
export class DecorativeSideShapesComponent {
}
